import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils';
import { AlgorithmTargetFormDataSchema } from './AlgorithmTargetFormDataSchema';
import {
  AlgorithmTargetFormDataType,
  AlgorithmTargetQueryDtoType,
} from './types';

export const AlgorithmTargetsFormDataSchema = z.object({
  algorithmId: z.number(),
  targets: transformNullish<
    AlgorithmTargetFormDataType[],
    AlgorithmTargetQueryDtoType[]
  >(AlgorithmTargetFormDataSchema.array(), []),
});
